// Payment schedule / terms from master API — same source as logistics provider profile (Commercial Terms).
import { useEffect, useMemo, useState } from 'react';
import CommonService from '../services/common.service';

const DEFAULT_PAYMENT_TERM = '50% advance, 50% before shipment';

/**
 * @returns {{
 *   paymentTermOptions: Array<{ id: string|number, label: string }>,
 *   paymentTermSelectOptions: Array<{ value: string, label: string }>,
 *   loading: boolean
 * }}
 */
export function usePaymentTermsMaster() {
  const [paymentTermOptions, setPaymentTermOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await CommonService.get('/master/factory-ShippingTerms');
        const data = res?.data ?? {};
        const list = data.paymentSchedule || data.master_payment_schedule || [];
        const arr = Array.isArray(list) ? list : [];
        const mapped = arr
          .map((r) => ({
            id: r.payment_schedule_id ?? r.id,
            label: r.payment_schedule ?? r.schedule_name ?? r.label ?? r.name,
          }))
          .filter((x) => x.label);
        if (!cancelled) setPaymentTermOptions(mapped);
      } catch {
        if (!cancelled) setPaymentTermOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const paymentTermSelectOptions = useMemo(() => {
    if (Array.isArray(paymentTermOptions) && paymentTermOptions.length) {
      return paymentTermOptions
        .map((o) => {
          const label = String(o.label ?? '').trim();
          return { value: label, label };
        })
        .filter((o) => o.value && o.label);
    }
    return [{ value: DEFAULT_PAYMENT_TERM, label: DEFAULT_PAYMENT_TERM }];
  }, [paymentTermOptions]);

  return { paymentTermOptions, paymentTermSelectOptions, loading };
}
